export default __webpack_public_path__ + "static/media/second-psychomotricite.58b16c88.jpg";